import React, { useEffect, lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import ServiciosHero from './components/ServiciosHero';
import ServiciosGrid from './components/ServiciosGrid';

const Desarrollo = lazy(() => import('../desarrollo/Desarrollo'));
const Migraciones = lazy(() => import('../migracion/Migracion'));
const Transformacion = lazy(() => import('../digitalizacion/Digitalizacion'));
const DataGovernance = lazy(() => import('../data/Data'));
const IncidentManager = lazy(() => import('../incident/Incident'));
const Consultoria = lazy(() => import('../consultoria/Consultoria'));
const InteligenciaArtificial = lazy(() => import('../ia/IA'));

const LoaderFallback = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 10 }}>
    <CircularProgress size={40} thickness={4} />
    <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
      Cargando...
    </Typography>
  </Box>
);

export default function Services() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      let attempts = 0;

      // Intentamos hacer el scroll repetidamente mientras los componentes "lazy" terminan de empujar el layout
      const tryScroll = setInterval(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          attempts++;
          // A los 15 intentos (1.5 segundos aprox), asumimos que el layout ya se estabilizó y paramos
          if (attempts >= 15) {
            clearInterval(tryScroll);
          }
        }
      }, 100);

      // Limpiamos el intervalo si el componente se desmonta o cambia la locación
      return () => clearInterval(tryScroll);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <Box component="main" sx={{ bgcolor: 'background.default' }}>
      <ServiciosHero />
      <ServiciosGrid useHashLinks={true} />

      <Box id="desarrollo" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <Desarrollo />
        </Suspense>
      </Box>
      <Box id="migracion" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <Migraciones />
        </Suspense>
      </Box>
      <Box id="digitalizacion" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <Transformacion />
        </Suspense>
      </Box>
      <Box id="data" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <DataGovernance />
        </Suspense>
      </Box>
      <Box id="incident" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <IncidentManager />
        </Suspense>
      </Box>
      <Box id="consultoria" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <Consultoria />
        </Suspense>
      </Box>
      <Box id="ia" sx={{ scrollMarginTop: '6rem' }}>
        <Suspense fallback={<LoaderFallback />}>
          <InteligenciaArtificial />
        </Suspense>
      </Box>
    </Box>
  );
}